import React from 'react';
import { Box, Flex, FlexColumn, Text } from 'core/components';
import AsnLink from 'app/components/links/AsnLink';
import { groupVantagePointsByCollector } from '@kentik/ui-shared/synthetics/bgp';

/*
  Renders sanitized vantage point names from a BGP alarm grouped by dataset, then by collector,
  with a single row per peer showing its ASN and IP
*/
export default function VantagePointList({ names, truncated }) {
  const { datasets, unparsed } = groupVantagePointsByCollector(names);

  if (datasets.length === 0 && unparsed.length === 0) {
    return null;
  }

  return (
    <FlexColumn gap={2}>
      <FlexColumn gap={2} maxHeight={280} overflow="auto">
        {datasets.map(({ dataset, collectors }) => (
          <Box key={dataset}>
            <Text as="div" fontWeight="bold" small>
              {dataset}
            </Text>
            <FlexColumn gap="4px" ml={1} mt="2px">
              {collectors.map(({ collector, vantagePoints }) => (
                <Box key={collector}>
                  <Text as="div" muted small>
                    {collector}
                  </Text>
                  <FlexColumn ml={1}>
                    {vantagePoints.map(({ name, asn, peerAsn, ip }) => (
                      <Flex key={name} gap={1} alignItems="baseline">
                        <Box width={72} flex="0 0 auto">
                          <AsnLink asn={peerAsn}>
                            <Text small>{asn}</Text>
                          </AsnLink>
                        </Box>
                        <Text small muted style={{ wordBreak: 'break-all' }}>
                          {ip}
                        </Text>
                      </Flex>
                    ))}
                  </FlexColumn>
                </Box>
              ))}
            </FlexColumn>
          </Box>
        ))}

        {unparsed.length > 0 && (
          <Box>
            <Text as="div" fontWeight="bold" small>
              Other
            </Text>
            <FlexColumn ml={1}>
              {unparsed.map((name) => (
                <Text key={name} small muted style={{ wordBreak: 'break-all' }}>
                  {name}
                </Text>
              ))}
            </FlexColumn>
          </Box>
        )}
      </FlexColumn>

      {truncated && (
        <Text muted fontStyle="italic" small>
          Additional vantage points were omitted.
        </Text>
      )}
    </FlexColumn>
  );
}
